import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, asapScheduler } from 'rxjs';
import { distinctUntilChanged, observeOn } from 'rxjs/operators';

export interface LoaderState {
  show: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly loaderSubject = new BehaviorSubject<LoaderState>({ show: false });
  readonly loaderState$: Observable<LoaderState> = this.loaderSubject.asObservable().pipe(
    observeOn(asapScheduler),
    distinctUntilChanged((previous, current) => previous.show === current.show)
  );
  constructor() {}
  show(): void {
    this.loaderSubject.next({ show: true });
  }
  hide(): void {
    this.loaderSubject.next({ show: false });
  }
}
